<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{"BLACKLIST_ERROR.MESSAGE" | translate}}</p>
<app-button (click)="logout()" label="{{'BLACKLIST_ERROR.BUTTON' | translate}}"></app-button>

